module.exports = __webpack_public_path__ + "static/img/nav-icon_5.272eef3e.png";